var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 26.6665C30.0002 21.1437 34.4773 16.6665 40.0001 16.6665C45.523 16.6665 50.0002 21.1437 50.0002 26.6665C50.0002 32.1894 45.523 36.6665 40.0002 36.6665C34.4773 36.6665 30.0002 32.1894 30.0002 26.6665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 63.3332C47.9293 63.3332 54.9347 59.3781 59.1512 53.3332C54.9347 47.2882 47.9293 43.3332 40.0002 43.3332C32.071 43.3332 25.0656 47.2882 20.8491 53.3332C25.0656 59.3781 32.071 63.3332 40.0001 63.3332Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3332 39.9998C73.3332 58.4093 58.4093 73.3332 39.9998 73.3332C21.5903 73.3332 6.6665 58.4093 6.6665 39.9998C6.6665 21.5903 21.5903 6.6665 39.9998 6.6665C58.4093 6.6665 73.3332 21.5903 73.3332 39.9998ZM68.3332 39.9998C68.3332 24.3518 55.6479 11.6665 39.9998 11.6665C24.3518 11.6665 11.6665 24.3518 11.6665 39.9998C11.6665 46.9159 14.1446 53.253 18.2612 58.1722C18.2611 58.1723 18.2612 58.1721 18.2612 58.1722C21.4535 61.987 25.631 64.9489 30.4028 66.6665C33.3998 67.7453 36.6312 68.3332 39.9998 68.3332C55.6479 68.3332 68.3332 55.6479 68.3332 39.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.632912d7f5b278bb1050d1c795ab57e0.svg";
export { ForwardRef as ReactComponent };